import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

export function MailToButton({ children, mailto, subject, ...props }) {
  const prefix = (p, s) => {
    return s ? p + s : "";
  };

  return (
    <Button
      primary
      as="a"
      href={`mailto:${mailto}${prefix("?subject=", subject)}`}
      {...props}
    >
      {children}
    </Button>
  );
}

MailToButton.propTypes = {
  children: PropTypes.node.isRequired,
  mailto: PropTypes.string.isRequired,
  subject: PropTypes.string,
};

MailToButton.defaultProps = { subject: undefined };

export default MailToButton;
